import React from 'react';
import moment from 'moment';

import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import momentTimezonePlugin from '@fullcalendar/moment-timezone';

import { useDispatch } from 'react-redux';
import { setForm } from '@store/policies/schedule/actions';

import { formatRecordForForm } from './utils';
import { TableWrapper } from './styled';
import useFetchSchedules from '@src/pages/Precision/hooks/useFetchSchedules';
import { scheduleStatus, messageMap, buildPolicyListTitle } from '@store/policies/schedule/utils';

const timeDisplayFormat: any = {
  hour: 'numeric',
  minute: '2-digit',
  hour12: false,
};

const ScheduleCalender = ({ canEdit }) => {
  const dispatch = useDispatch();

  const { orderedRows: actiavteEvents = [] } = useFetchSchedules('activate');
  const { orderedRows: reorderEvents = [] } = useFetchSchedules('reorder');

  const allRows = [...actiavteEvents, ...reorderEvents];

  const calendarEvents = allRows.map((row) => {
    return {
      ...row,
      title: row.type === 'activate' ? buildPolicyListTitle(row.policyList) : 'Reorder',
      start: row.triggerAt,
      backgroundColor: `${messageMap[row.state] ? messageMap[row.state].backgroundColor : ''}`,
      classNames:
        row.state === scheduleStatus.pending ? ['pending-event'] : ['not-waiting-schedule'],
    };
  });

  const handleEventClick = ({ event }) => {
    const formData: any = formatRecordForForm({ ...event.extendedProps, id: event.id });
    if (formData.state !== scheduleStatus.pending) {
      return;
    }
    dispatch(setForm(formData));
  };

  return (
    <TableWrapper>
      <FullCalendar
        plugins={[momentTimezonePlugin, dayGridPlugin, timeGridPlugin, listPlugin]}
        timeZone={moment().tz()}
        initialView="dayGridMonth"
        headerToolbar={{
          left: 'prev,next today',
          center: 'title',
          right: 'dayGridMonth,timeGridWeek,listWeek',
        }}
        eventDisplay="list-item"
        events={calendarEvents}
        eventClick={canEdit ? handleEventClick : undefined}
        allDaySlot={false}
        // height={700}
        aspectRatio={2.5}
        eventTimeFormat={timeDisplayFormat}
        slotLabelFormat={timeDisplayFormat}
      />
    </TableWrapper>
  );
};

export default ScheduleCalender;
